import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function BookingSlotOptionList({
  slots = [],
  selectedValue = '',
  onSelect,
  disabled = false,
}) {
  if (!slots.length) return null;

  return (
    <div className="li-booking-slot-options">
      <div className="li-booking-section-head">
        <h2 className="li-booking-section-title">Available times</h2>
        <p className="li-booking-section-copy">
          Select one of the open interview slots below, then confirm your request.
        </p>
      </div>
      <div className="li-booking-slot-options-grid">
        {slots.map((slot) => {
          const value = String(slot?.value || '').trim();
          const isSelected = value && value === selectedValue;
          return (
            <button
              key={value || slot?.label}
              type="button"
              disabled={disabled || !value}
              className={[
                'li-booking-slot-option',
                isSelected ? 'is-selected' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => {
                if (isSelected) {
                  onSelect?.(null);
                  return;
                }
                onSelect?.(slot);
              }}
            >
              <span className="li-booking-slot-option-badge">Available</span>
              <span className="li-booking-slot-option-label">{slot?.label || value}</span>
              {isSelected ? (
                <span className="li-booking-slot-option-selected">
                  <CheckCircle2 size={16} />
                  Selected
                </span>
              ) : (
                <span className="li-booking-slot-option-cta">Select this time</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
